module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Choosen references")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "references-table table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (_vm.choosenRefs.length) ? _c('tbody', _vm._l((_vm.choosenRefs), function(item) {
    return _c('tr', {
      key: item.type + item.id,
      attrs: {
        "data-id": item.type + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteRef(item)
        }
      }
    }, [_vm._v("Delete")])])])
  }), 0) : _c('tbody', [_vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Reference type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    attrs: {
      "options": _vm.refTypeOptions
    },
    model: {
      value: (_vm.refType),
      callback: function($$v) {
        _vm.refType = $$v
      },
      expression: "refType"
    }
  })], 1)]), _vm._v(" "), (_vm.refType) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Reference entity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    ref: "refEntityModel",
    attrs: {
      "multiple": "",
      "filterable": false,
      "options": _vm.refEntityOptions,
      "label": "id"
    },
    on: {
      "search": _vm.onEntitySearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }], null, false, 1467187853),
    model: {
      value: (_vm.refEntity),
      callback: function($$v) {
        _vm.refEntity = $$v
      },
      expression: "refEntity"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n              type to search...\n            ")])], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.refType && _vm.refEntity && _vm.refEntity.length) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addRef
    }
  }, [_vm._v("Add")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("References")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v("Title")]), _vm._v(" "), _c('td', [_vm._v("Type")]), _vm._v(" "), _c('td', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("There are no content")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4b2a5b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/Referencer.vue
// module id = 873
// module chunks = 0